import { bindUrl, request } from "./request";
/**
 * 渔船新增
 * POST /oil/ship/create
 * @param {渔船新增} bodyParams - shipCreateReq
 */
export function createShip(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/client/ship/create", {}),
    method: "POST",
    data: bodyParams
  });
}
/**
 * 渔船详情
 * GET /oil/ship/detail
 * @param {Object} queryParams
 * @param {number} queryParams.id - 渔船id
 */
export function getShipDetail(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/ship/detail", {}),
    method: "GET",
    params: queryParams
  });
}
/**
 * 渔船列表
 * GET /oil/ship/list
 * @param {Object} queryParams
 * @param {number} queryParams.page - 页码
 * @param {number} queryParams.limit - 每页数量
 */
export function getShipList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/ship/list", {}),
    method: "GET",
    params: queryParams
  });
}

export function getTransportList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/admin/transport/list", {}),
    method: "GET",
    params: queryParams
  });
}
/**
 * 渔船编辑
 * POST /oil/ship/modify
 * @param {渔船编辑} bodyParams - shipModifyReq
 */
export function modifyShip(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/client/ship/modify", {}),
    method: "POST",
    data: bodyParams
  });
}
/**
 * 渔船共享
 * POST /oil/ship/share
 * @param {渔船共享} bodyParams - shipShareReq
 */
export function shareShip(bodyParams) {
  return request({
    url: bindUrl("/svc-oil/client/ship/share", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 渔船共享人列表
 * POST /oil/ship/share
 * @param {渔船共享} queryParams - shipShareReq
 */
export function getShareList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/ship/share/list", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 渔船付款人人列表
 * GET /oil/ship/payer/list
 * @param {Object} queryParams
 * @param {string} queryParams.shipId - 渔船id
 */
export function getPayerList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/client/ship/payer/list", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 交易员渔船付款人人列表
 */
export function getAdminPayerList(queryParams) {
  return request({
    url: bindUrl("/oil/admin/ship/payer/list", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 加油船列表
 * GET /oil/admin/ship/list
 */
export function getAdminShipList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/admin/ship/list", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 加油车列表
 * GET /oil/admin/car/list
 */
export function getAdminCarList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/admin/car/list", {}),
    method: "GET",
    params: queryParams
  });
}

/**
 * 客户渔船列表
 * GET /svc-oil/admin/client/ship/list
 */
export function getAdminClientShipList(queryParams) {
  return request({
    url: bindUrl("/svc-oil/admin/client/ship/list", {}),
    method: "GET",
    params: queryParams
  });
}
